<template>
  <van-popup
      v-model="videoConShow"
      closeable
      close-icon="close"
      get-container="#app"
      :safe-area-inset-bottom="true"
      @close="videoConClose"
  >
    <div ref="videoCon" style="width: 375px;overflow-x: hidden;">
      <div id="xgPlayer" class="xgPlayer"></div>
    </div>

  </van-popup>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data(){
    return {
      // indexVideo: null,
      videoConShow: false,

      player: null,//播放器实例
      playerConfig: {
        id: "xgPlayer",
        width: '371',
        height: '100%',
        "playsinline": false, // 内联模式(微信播放器)
        "whitelist": [""],
        "playbackRate": [0.5, 1, 1.5, 2],
        "closeVideoTouch": true,
        "x5-video-player-type": "h5", // 微信同层播放: h5
        // "x5-video-player-fullscreen": "true", // 微信全屏播放： true  false
        // "x5-video-orientation": "portraint", //微信横竖屏控制：横屏 landscape, 竖屏 portraint
      },
    }
  },
  components: {
  },
  computed:{
    ...mapGetters([
      'videoSrc'
    ]),
  },
  watch: {
    videoSrc(url){
      if(url){
        this.videoConShow = true
        this.initPlayer(url)
      }else {
        this.videoConShow = false
      }
    }
  },
  created(){},
  methods: {
    initPlayer(url, poster){
      this.playerConfig = {
        ...this.playerConfig,
        url,
        poster,
        height: document.body.clientHeight/10*9,
      };
      window.setTimeout(()=>{
        this.$refs.videoCon.innerHTML = `<div id="xgPlayer" class="xgPlayer"></div>`
        this.player = new Player(this.playerConfig);
      },100)
    },

    videoConClose(){
      this.$store.dispatch('video/setVideoSrc', '')
      this.player && typeof this.player.destroy === 'function' && this.player.destroy(true);
    },

  }
}
</script>

<style lang="less" scoped>

</style>